export default "__VITE_ASSET__998342f7__"